import { ADMIN_ROUTES, MEDIA_ROUTES } from '~/constants/router'
import { mediaRoles } from '~/modules/auth/conditions'
import { lazyRetry } from '~/utils/lazyRetry'

const NewMediaLibrary = lazyRetry(() => import('~/pages/NewMediaLibrary'))
const PantryMedia = lazyRetry(() =>
  import('@pantry/features').then((m) => ({ default: m.MediaPage })),
)

const MediaRouters = [
  {
    path: `${ADMIN_ROUTES.STORE}${MEDIA_ROUTES.MEDIA_LIBRARY}/:folderId?/:fileMode?`,
    component: NewMediaLibrary,
    pantryComponent: PantryMedia,
    layout: 'admin',
    exact: true,
    roles: mediaRoles,
    routeName: 'Media',
  },
]

export default MediaRouters
